export default __webpack_public_path__ + "static/media/computer-lock.6d531fc3.jpeg";